const src = import.meta.ROLLUP_FILE_URL_5ueHAtn9JtiQ3lCiqsnAfg;
export default {
  src,
  srcSet: src + " " + 324 + "w",
  width: 324,
  height: 480,
};